module.exports = __webpack_public_path__ + "static/dog-1-c9a419b32babf8ccdaa2b41db63a3311.png";